<template>
  <div class="bottomCardWrapper">
    <div
      v-if="displayBackgroundCard"
      class="backgroundBottomCardWrapper"
      :style="{'height': typeof height === 'number' ? `${height+12}px` : 'auto'}">
      <div class="backgroundBottomCard"></div>
    </div>

    <div class="bottomCard" v-show="true" :style="{'height': typeof height === 'number' ? `${height}px` : 'auto'}">
      <div v-if="displayControls" class="bottomCardControls">
        <LeftTitle text="Back" v-on:click.native="$emit('goBack')"></LeftTitle>
        <v-progress-circular
            :size="24"
            :width="3"
          :value="progress"
          color="#0A84FF"
        ></v-progress-circular>

      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>

  import SecondaryTextButton from "@/components/buttons/SecondaryTextButton";
  import LeftTitle from "@/components/buttons/LeftTitle";
  import RightTitle from "@/components/buttons/RightTitle";
  export default {
    name: 'BottomCard',
    components: {RightTitle, LeftTitle, SecondaryTextButton},
    props: ['progress', 'displayBackgroundCard', 'displayControls', 'height'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style lang="scss">
 @import "src/assets/scss/index";



  .bottomCard {
    background: #F4F3F3;
    box-shadow: -1px -3px 10px rgb(0 0 0 / 0.25);
    border-radius: 10px 10px 0px 0px;
    transition: all 0.3s ease-in !important;

    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 10;

  }

  .bottomCard .chatInputWrapper {
    margin-bottom: 3.313rem;
  }

  .bottomCard .cardInput {
    margin-bottom: 2.313rem;
  }

 .bottomCard .cardInput:focus-within {
   margin-bottom: $primaryMargin;
 }

  .bottomCard .chatInputWrapper:focus-within {
    margin-bottom: $primaryMargin;
  }



.backgroundBottomCardWrapper {
    position: absolute;
    bottom: 0;
    padding-bottom: 3.313rem;
    width: 100%;
    z-index: 1;
  }

  .backgroundBottomCard {
    background: #e6e6e6;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px 10px 0px 0px;
    bottom: 0;
    padding-bottom: 3.313rem;
    width: 90%;
    margin: 0 auto;
    height: 100%;
    content: "";
  }

  .bottomCardControls {
    height: 3rem;
    padding: $primaryPadding;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }



</style>
